module.exports = __webpack_public_path__ + "img/affiliate.fa8d8b99.svg";